import React from "react";
import { Button, useColorModeValue } from "@chakra-ui/react";
import { ButtonProps } from "@chakra-ui/button/dist/types/button";

import { useGetThemeColors } from "ChakraTheme";

interface IProps extends ButtonProps {}

const GreenButton = React.forwardRef<HTMLButtonElement, IProps>(
  ({ children, ...props }, ref) => {
    const colors = useGetThemeColors();
    const backgroundBtnColor = useColorModeValue(
      colors.green[600],
      colors.green[200]
    );
    const hoverBackgroundBtnColor = useColorModeValue(
      colors.green[700],
      colors.green[400]
    );
    const activeBackgroundBtnColor = useColorModeValue(
      colors.green[800],
      colors.green[500]
    );
    const textColor = useColorModeValue(colors.white, colors.black);

    return (
      <Button
        ref={ref}
        color={textColor}
        bg={backgroundBtnColor}
        _hover={{
          bg: hoverBackgroundBtnColor,
        }}
        _active={{
          bg: activeBackgroundBtnColor,
        }}
        {...props}
      >
        {children}
      </Button>
    );
  }
);

export { GreenButton };
